import React from "react";
import "./Backstage.css";
import TextLabel from "../../Controls/TextLabel.mjs";
import helperClass from "./backstageHelper.mjs";
import {Button, ButtonGroup, ButtonToolbar, Label} from "reactstrap";
import appLib from "../../libs/appLib.mjs";
import Injection from "./Injection.mjs";
import InjectionEditor from "./InjectionEditor.mjs";
import InjectionIcon from "../../media/images/InjectionIcon.mjs";

const G = window.glob;

const Backstage = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			bh: new helperClass(),
			player: G.getStatus('Player'),
			historyDirection: (G.getPref('HistoryDirection') || 'up'),
			feed: G.getStatus('GameChosen')?.feedStatus,
			lastAutoCommand: 0,
			autoInjections: false,
			injections: false,
			logHide: {}
		};
		this.state.game = G.getStatus('Game');
		this.uid = window.glob.generateUid('Backstage');
		this.nextInjections = this.nextInjections.bind(this);
		this.renderControls = this.renderControls.bind(this);
		this.renderHistory = this.renderHistory.bind(this);
		this.doCommand = this.doCommand.bind(this);
		this.clearTimeout = this.clearTimeout.bind(this);
		this.parseEvent = this.parseEvent.bind(this);
	}

	componentDidMount() {
		G.register('Copione', (c) => {
			this.state.bh.setCopione(c);
		}, this.uid);
		G.register('Player', p => {
			this.setState({player: p});
		}, this.uid);
		G.register('Game', g => {
			this.state.bh.setGame(g);
			this.setState({game: g}, () => {
				this.nextInjections()
			});
		}, this.uid);
		G.register('Prefs', p => {
			if (!p) return;
			if (p?.HistoryDirection) this.setState({historyDirection: p.HistoryDirection});
		}, this.uid);
		G.register('GameChosen', gc => {
			this.setState({feed: gc?.feedStatus});
		}, this.uid);
		G.register('event:Admin', e => {
			if (e?.command) this.parseEvent(e.command, e.data);
		}, this.uid);
	}

	componentWillUnmount() {
		this.clearTimeout();
		G.deregister(this.uid);
	}

	clearTimeout() {
		if (!this.state.injTimeout) return;
		try {
			window.clearTimeout(this.state.injTimeout)
		} catch (e) {
		}
		this.setState({injTimeout: undefined});
	}

	nextInjections() {
		if (!this.state.bh) return;
		this.clearTimeout();
		const newState = {};
		const makeTimeout = () => {
			this.clearTimeout();
			const injTimeout = window.setTimeout(() => {
				this.nextInjections()
			}, 500);
			this.setState({injTimeout: injTimeout});
		}
		if (this.state.loading || !this.state.game) return makeTimeout();
		const clu = this.state.bh.getLastupdate();
		if (this.state.lastAutoCommand >= clu) return makeTimeout();
		if (this.state.autoInjections.length) {
			this.doCommand.apply(this, this.state.autoInjections[0]).then(() => {
				const pi = this.state.autoInjections;
				pi.shift();
				this.setState({autoInjections: pi, lastAutoCommand: clu});
				return makeTimeout();
			})
		}
		const nas = this.state.bh.nextInjection();
		if (Array.isArray(nas?.auto) && nas.auto.length) {
			this.doCommand('injection', nas.auto.shift()).then(() => {
				this.setState({lastAutoCommand: clu});
				this.setState()
				return makeTimeout();
			}).catch(e => {
				console.error(e);
			});
			return;
		}
		newState.injections = false;
		if (Array.isArray(nas?.manual) && nas.manual.length) {
			newState.injections = nas.manual;
		}
		if (nas.nextTime) {
			newState.injTimeout = window.setTimeout(() => {
				this.nextInjections()
			}, nas.nextTime);
		}
		this.setState(newState);
	}

	parseEvent(command, data) {
		switch (command) {
			case 'MarkStepDone':
				const d = {id: data?.id};
				if ( data?.failure ) d.failure = data.failure;
				this.doCommand('donestep', d);
				break;
			case 'DoInjection' :
				this.doCommand('injection', {id: data?.id});
				break;
			case 'FullInjection' :
				this.doCommand('injection', data );
				break;
			case 'CancelInjection' :
				this.doCommand('injection', {id: data?.id, skip: true});
				break;
			default:
				break;
		}
	}

	doCommand(command, data) {
		return new Promise((resolve, reject) => {
			this.setState({loading: true}, async () => {
				const sid = G.getStatus('Scenario')?.id;
				try {
					await G.api({entity: "admin", operation: command}, data);
					await G.api({entity: 'game', operation: 'refresh'}, {scenario: sid});
					this.setState({loading: false}, () => {
						resolve(true);
					});
				} catch (e) {
					console.error(e);
					this.setState({loading: false}, () => {
						reject(e)
					});
				}
			});
		});
		// G.api(
		// 	{ entity: "admin", operation: command }, data
		// ).then( ( o )=>{
		// 	appLib.refreshAllData().then( ()=>{
		// 		setTimeout( ()=>{ this.setState({ loading: false }); }, 500);
		// 	});
		// }).catch( (e)=>{
		// 	console.log(e);
		// 	this.setState({ loading: false });
		// });
	}

	renderControls() {
		const dirup = (this.state.historyDirection === 'up');
		const BH = this.state.bh;
		if (!BH) return '';
		const allBtns = [];
		allBtns.push(
			<Button
				key={"HistoryDirection"}
				className={"HistoryDirection"}
				color={"secondary"}
				onClick={() => {
					G.setPref('HistoryDirection', dirup ? 'down' : 'up', true);
				}}
			>
				<i>
					<TextLabel value={dirup ? 'up' : 'down'} lang={"icon"}/>
				</i>
				<b>
					<TextLabel value={"Log"}/>
				</b>
			</Button>
		);
		if ( this.state.feed ) allBtns.push(
			<Button
				key={"export"}
				color={"primary"}
				onClick={() => { window.open("./report.html", "gamedetails"); }}
			>
				<b>
					<TextLabel value={"Report"}/>
				</b>
				<i>
					<TextLabel value={"attach"} lang={"icon"}/>
				</i>
			</Button>
			// <Button
			// 	key={"export"}
			// 	color={"primary"}
			// 	onClick={() => {
			// 		window.open(G.prop.uri.api + "cs/game/export/?id=" + this.state.game.id +'&lang=' + G.getLanguage(), "gamedetails");
			// 	}}
			// >
			// 	<b>
			// 		<TextLabel value={"Report"}/>
			// 	</b>
			// 	<i>
			// 		<TextLabel value={"attach"} lang={"icon"}/>
			// 	</i>
			// </Button>
		);
		const gmBtns = [];
		const gm = !!this.state.player.admin?.gameMaster;
		if (gm) {
			const btns = [(
				<Button
					key={"ExitGame"}
					color={"danger"}
					onClick={() => {
						appLib.closeGame();
					}}
				>
					<i>
						<TextLabel value={"cancel"} lang={"icon"}/>
					</i>
					<b>
						<TextLabel value={"Exit"}/>
					</b>
				</Button>
			)];
			if (BH.getStatus() === 'pending') {
				btns.push(
					<Button
						key={"start"}
						color={"primary"}
						onClick={() => {
							this.doCommand('start');
						}}
					>
						<b>
							<TextLabel value={"Start"}/>
						</b>
						<i>
							<TextLabel value={"forward"} lang={"icon"}/>
						</i>
					</Button>
				);
			} else if (appLib.getConfigOption('pause').enabled && BH.canPause()) {
				btns.push(
					<Button
						key={"start"}
						color={"warning"}
						onClick={() => {
							this.doCommand('pause');
						}}
					>
						<i>
							<TextLabel value={"pause"} lang={"icon"}/>
						</i>
						<b>
							<TextLabel value={"Pause"}/>
						</b>
					</Button>
				);
			}
			gmBtns.push(
				<ButtonToolbar className={"GameControls"} key={"GameControls"}>
					<ButtonGroup className={"btn-icon"}>
						{btns}
					</ButtonGroup>
				</ButtonToolbar>
			);
		}
		return (
			<div className={"GameToolbar"}>
				<ButtonToolbar className={"GameHiControl"} key={"GameHiControl"}>
					<ButtonGroup className={"btn-icon"}>
						{allBtns}
					</ButtonGroup>
				</ButtonToolbar>

				<div className={"TimerBar"} key={"Timer"}>
					{this.state.bh.renderTimer()}
				</div>
				{gmBtns}
			</div>
		);
	}

	renderHistory() {
		const hi = this.state.bh ? this.state.bh.renderHistory() : [];
		return (
			<div className={"History " + this.state.historyDirection} key={"History"}>
				{hi.map((h, idx) => (
					<div className={"GameEvent"} key={idx}>
						{h}
					</div>
				))}
			</div>
		);
	}

	render() {
		if (!this.state.game?.status) return '';
		if (!this.state.player?.admin) return '';
		const gm = this.state.player?.admin?.gameMaster;
		return (
			<div className={"Backstage"} id={this.uid} key={this.state.game.lastupdate}>
				<h1 key={"Title"}>
					{this.state.game?.name || <TextLabel value={"Backstage"}/>}
				</h1>
				{this.renderControls()}
				<div className={"Stage"} key={"Stage"}>
					<div className={"HistoryWrap"}>
						<div className={"FilterButtons"}>
							<Label>
								<TextLabel value={"Hide"}/>
							</Label>
							<ButtonGroup className={"btn-icon ViewControls"}>
								<Button
									outline={true}
									color={"danger"}
									onClick={() => {
										const h = this.state.logHide;
										h.step = !h.step;
										this.setState({logHide: h});
									}}
									active={!!this.state.logHide.step}
									title={ G.label('Step') }
								>
									<i>⏱️</i>
								</Button>
								{
									['im', 'mail'].map(x => (
										<Button
											key={x}
											outline={true}
											color={"danger"}
											onClick={() => {
												const h = this.state.logHide;
												h[x] = !h[x];
												this.setState({logHide: h});
											}}
											active={!!this.state.logHide[x]}
											title={G.label("eventType-" + x + "-desc")}
										>
											<i>
												<TextLabel value={"eventType-" + x}/>
											</i>
										</Button>
									))
								}
								<Button
									outline={true}
									color={"danger"}
									onClick={() => {
										const h = this.state.logHide;
										h.injections = !h.injections;
										this.setState({logHide: h});
									}}
									active={!!this.state.logHide.injections}
									title={ G.label('Injections')}
								>
									<i>
										<InjectionIcon />
									</i>
								</Button>
							</ButtonGroup>
							<Label>
								<TextLabel value={"Details"}/>
							</Label>
							<ButtonGroup className={"btn-icon"}>
								<Button
									color={"secondary"}
									onClick={() => {
										document.querySelectorAll('.GameEvent', document.getElementById(this.uid)).forEach(n => {
											n.classList.remove('viewDetails');
										});
									}}
									title={ G.label('Hide details') }
								>
									<i>
										<TextLabel value={"forward"} lang={"icon"}/>
									</i>
								</Button>
								<Button
									color={"secondary"}
									onClick={() => {
										document.querySelectorAll('.GameEvent', document.getElementById(this.uid)).forEach(n => {
											n.classList.add('viewDetails');
										});
									}}
									title={ G.label('Show details') }
								>
									<i>
										<TextLabel value={"down"} lang={"icon"}/>
									</i>
								</Button>
							</ButtonGroup>
						</div>
						<div
							className={
								["HistoryInnerWrap"].concat(
									Object.entries(this.state.logHide)
										.map(([k, v]) => ( v ? 'hide-' + k : '' ))
								).filter( x => !!x ).join(' ')
							}
						>
							{this.renderHistory()}
						</div>
					</div>
					{
						gm ? (
							<div
								className={"Injections " + ((this.state.injections) ? 'expanded' : 'collapsed')}
								key={"Injections"}
							>
								{
									this.state.injections && (
										<>
											<h1>
												<TextLabel value={"Injections"}/>
											</h1>
											{this.state.injections.map(i => <Injection key={i.id} injection={i}/>)}
										</>
									)
								}
							</div>
						) : ''}
				</div>
				{ gm && <InjectionEditor /> }
			</div>
		)
	}
}

export default Backstage;